const InnerLoader = ({ textStatus = true, text = "Data Load...", className, wrapperClass, style }) => {
    return (
        <div className={`tableDataLoader ${wrapperClass}`}>
            <div className="tableDataLoader-wrapper">
                <div className={`loader ${className}`} style={style}></div>
                {
                    textStatus ? (
                        <span>{text}</span>
                    ) : (
                        null
                    )
                }
            </div>
        </div>
    )
}

export default InnerLoader
